import {
    DialogPositioningBehavior,
    DialogType,
    DialogWidget,
    HorizontalOriginOption, OriginOptions, TabStyles, VerticalOriginOption
  } from '@tableau/widgets';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Messages } from '../../codegen/Localize';
import { AngularDirective } from '../../common/react/components/AngularDirective';
import { AngularContext } from '../../ts/factories/AngularContextFactory';
import { Hover } from '../spaces/Components/Hover';

export interface SiteRolePopoverProps {
    readonly angularContext: AngularContext;
    readonly showIconWithoutTitle?: boolean;
    readonly className?: string;
}

export interface SiteRolePopoverState {
    readonly showingPopover: boolean;
}

const AnchorOrigin: OriginOptions = {
    horizontal: HorizontalOriginOption.right,
    vertical: VerticalOriginOption.centerY
};

const StackedOrigin: OriginOptions = {
  horizontal: HorizontalOriginOption.right,
  vertical: VerticalOriginOption.centerY
};

const IconPadding: React.CSSProperties = {
  paddingLeft: 70
};

const DialogStyle: React.CSSProperties = {
  position: 'relative',
  border: '1px solid rgb(178,178,178)',
  borderRadius: 1,
  boxShadow: '0 7px 15px rgba(0,0,0,0.2)',
  minHeight: 60
};

export class SiteRolePopover extends React.PureComponent<SiteRolePopoverProps, SiteRolePopoverState> {
    private anchorElement: HTMLElement;

    constructor(props: SiteRolePopoverProps) {
      super(props);
      this.state = { showingPopover: false };
    }

    public render() {
      return (
        <span className={this.getRowClassName()}>
          {this.getRowTitle()}
          <Hover groupName="siterolepopover"
                onEnter={this.showPopover}
                onLeave={this.hidePopover}
                leaveOnScroll={false}
                className="tb-header-row-icon tb-icon-help"
                enterDelay={0}
                useDocument={true}>
            <div ref={this.setAnchorElement} style={IconPadding}>
              { this.state.showingPopover && this.renderSiteRolePopover() }
            </div>
          </Hover>
        </span>
      );
    }

    private getRowClassName() {
      if (this.props.className) {
        return this.props.className;
      }

      if (this.props.showIconWithoutTitle) {
        return 'tb-row-icon-on-right-react';
      }
      return 'tb-site-role-column-header';
    }

    private getRowTitle() {
      if (this.props.showIconWithoutTitle) {
        return (null);
      }
      return (<span> {Messages.siteRole()} </span>);
    }

    private renderSiteRolePopover() {
      return (
        <div>
          <DialogWidget stackingRootId = {'ng-app'}
                              testId={'site-role-popover'}
                              type={DialogType.Uber}
                              showCloseButton={false}
                              onCloseRequest={this.hidePopover}
                              positioningBehavior={DialogPositioningBehavior.Anchored}
                              isModal={false}
                              showFooter={false}
                              anchorEl={this.anchorElement}
                              disableAutoFocus={true}
                              shouldReturnFocusOnClose={true}
                              anchorOrigin={AnchorOrigin}
                              stackedOrigin={StackedOrigin}
                              shouldAdjustPositionOnWindowResize={false}
                              dialogStyle={DialogStyle}
                              title={Messages.siteRolePopoverTitle()}
                              >
                <AngularDirective angularContext={this.props.angularContext}
                                  template={'<tb:site-role-permissions-table></tb:site-role-permissions-table>'}/>
          </DialogWidget>
        </div>
      );
    }

    private showPopover = () => {
      this.setState({ showingPopover: true });
    }

    private hidePopover = () => {
      this.setState({ showingPopover: false });
    }

    private setAnchorElement = (el: HTMLElement) => {
      this.anchorElement = el;
    }
  }
